import { Component, OnInit, Inject, PLATFORM_ID, ChangeDetectorRef } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { DataServiceService } from 'src/app/services/data-service.service';
import { SeoService } from 'src/app/services/seo.service';
import { GlobalService } from 'src/app/services/global.service';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faIdCard } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TwitterComponent } from '../../_components/twitter/twitter.component';
import { LinkedinComponent } from '../../_components/linkedin/linkedin.component';
import { FacebookComponent } from '../../_components/facebook/facebook.component';
import { SafePipe } from 'src/app/pipes/safe.pipe';

@Component({
    selector: 'app-advisor-details',
    templateUrl: './advisor-details.component.html',
    styleUrls: ['./advisor-details.component.scss'],
    imports:[FontAwesomeModule,RouterModule,CommonModule,TwitterComponent,LinkedinComponent,FacebookComponent,SafePipe]
})
export class AdvisorDetailsComponent implements OnInit {

  pageUrl = '';
  tweet = encodeURIComponent(("meta[name='description']")); //.attr("content"));

  advisor
  clientServices
  faEnvelope = faEnvelope;
  faIdCard = faIdCard;


  constructor(private route: ActivatedRoute, private dataservice: DataServiceService, private seoservice: SeoService, private globalservice: GlobalService, @Inject(PLATFORM_ID) private platformId: Object, private cdr: ChangeDetectorRef) {
    if (isPlatformBrowser(this.platformId)) {
      this.pageUrl = encodeURIComponent(document.URL);
    }
  }

  ngOnInit() {

    this.route.params.subscribe(params => {
      if (params.name.toLowerCase() == "elizabeth")
      {
        this.dataservice.getClientServices("?$filter=id eq 69")
          .subscribe
          (
            liz =>
            {
              liz[0].imageUrl = liz[0].imageUrl.replace("177x100", "512x288");
              this.advisor = liz[0];
              this.advisor.vCardUrl = this.advisor.vCardUrl = "https://data2.ifa.com/api/v1/vcard/?name_first=" + this.advisor.first + "&name_last=" + this.advisor.last;
              this.seoservice.updateTitle(this.advisor.title);
              this.seoservice.updateMetaInfo(
              this.advisor.description,
              this.advisor.author,
              this.advisor.keywords);

               this.cdr.detectChanges();
            }
          )
      }
      else
      {
// $&("paramaters", params)
        this.dataservice.getAdvisor("?$filter=id eq " + this.globalservice.advisorsGetIdFromName(params.name)).subscribe(resp => {
// $&("resp", resp)
        resp[0].imageUrl = resp[0].imageUrl.replace("177x100", "512x288");
        this.advisor=resp[0];
        this.advisor.vCardUrl = "https://data2.ifa.com/api/v1/vcard/?name_first=" + this.advisor.first + "&name_last=" + this.advisor.last;
// $&(this.advisor)
        this.seoservice.updateTitle(this.advisor.title);
        this.seoservice.updateMetaInfo(
        this.advisor.description,
        this.advisor.author,
        this.advisor.keywords       
        );
        
        this.cdr.detectChanges();

        })
      }


      
      // this.dataservice.getClientServices("?$filter=id eq " + this.globalservice.cssGetIdFromName(params.fullName)).subscribe(resp => {
      //   console.log("resp", resp)
      //   resp[0].imageUrl = resp[0].imageUrl.replace("177x100", "512x288");
      //   this.clientServices=resp[0];
      //   console.log(this.clientServices)

      // })

    } )

  }

  socialWindow(url) {
    var left = (screen.width - 570) / 2;
    var top = (screen.height - 570) / 2;
    var params = "menubar=no,toolbar=no,status=no,width=570,height=570,top=" + top + ",left=" + left;
    window.open(url, "NewWindow", params);
  }

  emailCurrentPage() {
    window.location.href = "mailto:?subject=" + document.title + "&body=" + escape(window.location.href);
  }

  socialsharefacebook() {
    var url = "https://www.facebook.com/sharer.php?u=" + this.pageUrl;
    this.socialWindow(url);
  };

  socialsharetwitter() {
    var url = "https://twitter.com/intent/tweet?url=" + this.pageUrl + "&text=" + this.tweet;
    this.socialWindow(url);
  };

  socialsharelinkedin() {
    var url = "https://www.linkedin.com/shareArticle?mini=true&url=" + this.pageUrl;
    this.socialWindow(url);
  }

}
